import React from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import ONU from "./ONU";
import FiberCores from "./FiberCores";
import ZoneDashboard from "./ZoneDashboard";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function InventoryTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          textColor="inherit"
          TabIndicatorProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        >
          <Tab label="Dashboard" {...a11yProps(0)} sx={{ color: "white" }} />

          <Tab label="Cores" {...a11yProps(1)} sx={{ color: "white" }} />
          <Tab label="ONU" {...a11yProps(2)} sx={{ color: "white" }} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ZoneDashboard />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <FiberCores />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ONU />
      </TabPanel>
    </Box>
  );
}
